export default __webpack_public_path__ + "static/media/btn_lt_arrow.855bf160.svg";